import { SET_ALLERGIES } from '../actions/allergy';

let initialState = {
  allergiesData: [],
};

const allergies = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALLERGIES:
      return {
        ...state,
        allergiesData: action.payload,
      };

    default:
      return state;
  }
};

export default allergies;
